module.exports = __webpack_public_path__ + "img/icon-close.87d20c21.svg";